const requestAnimationFrame = (cb) => window.requestAnimationFrame(cb);
export default requestAnimationFrame;
